module.exports = __webpack_public_path__ + "static/media/MPS_logo.1f0ff6c3.svg";